// @nuxtjs/onesignal のプラグイン（node_modules/@nuxtjs/onesignal/templates/plugin.js）の代わり。
// 中身は同じ（window.OneSignal のキューを用意して init を積み、$OneSignal を inject）だが、
// init は許可ホスト（cp.gyms.jp）でだけ積む。理由・差し替えの仕組みは config/oneSignal.js。
import {
  isOneSignalAllowedHost,
  oneSignalInitOptions
} from '~/config/oneSignal'

export const setupOneSignal = (win, initOptions) => {
  win.$OneSignal = win.OneSignal = win.OneSignal || []
  if (isOneSignalAllowedHost(win.location && win.location.hostname)) {
    win.OneSignal.push(['init', initOptions])
  }
  return win.OneSignal
}

export default function (ctx, inject) {
  // appId は nuxt.config.js の env.ONESIGNAL_APP_ID（ビルド時に埋め込み。今までの oneSignal.init.appId と同じ値）
  const OneSignal = setupOneSignal(
    window,
    oneSignalInitOptions(process.env.ONESIGNAL_APP_ID)
  )
  inject('OneSignal', OneSignal)
}
